import { configData } from "../config/systemconfigurationconstants";
import UseLambdaInvocations from '../hooks/useLambdaInvocations';
import lambdaConfig from '../hooks/lambdaConfig';
import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
const DgGeneralInfoSave = ({ getGeneralInfoDetailsForLoan, conditionjson, setConditionJson, LoanStatus }) => {
    const navigate = useNavigate();
    const { invokeLambda, loading, error } = UseLambdaInvocations();
    const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
    const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));

    const saveAddOrWaivedCondition = async () => {
        try {
            const parsedBody = await invokeLambda(configData.CONDITION_ACTIONS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                ConditionJSON: conditionjson,
            });
            if (parsedBody.Status) {
                toast.success("Condition cleared Sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            } else {
                toast.error("Condition Cleard UnSucessfull", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
            await getGeneralInfoDetailsForLoan();
        } catch (err) {
            // Handle error if needed
        }
    }
    const gotoDashboard = () => {
        navigate('/dashboard');
    }

    const hasRightsToSave = () => {
        if (rolesAndRights !== null) {
            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "SAVE")?.RightId;
            if(userRights.some(el => el.RightId == rightID)) {
                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
            }
        }
    }

    return (<>
        {hasRightsToSave() && (<button type="button" disabled={LoanStatus==="Completed"} class="btn btn-outline-success btn-sm me-1" onClick={saveAddOrWaivedCondition}>Save</button>)}
        <button type="button" class="btn btn-outline-primary btn-sm me-1" onClick={gotoDashboard}>Cancel</button>
    </>)
}
export default DgGeneralInfoSave